import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Constants } from '../core/constants/constants';
import { Layout } from '../core/classes/layout';
import { ILayout } from '../core/models/layout.vm';
import { ITool } from '../core/models/tool.vm';
import { LoaderService } from '../core/services/loader.service';
import { toolInformation } from './tool-info';

@Component({
  selector: 'app-tool',
  templateUrl: './tool.component.html',
  styleUrls: ['./tool.component.scss']
})
export class ToolComponent {

  public loadingError: string = null;
  public toolInformation: Array<ITool> = toolInformation.getToolInfo();
  public filteredTools: Array<ITool> = toolInformation.getToolInfo();
  public searchTerm: string = '';
  public currentYear: number = Constants.currentYear;
  public layout: ILayout = new Layout('Tools', ['Internal tools and resources'], '');

  public darkMode$: Observable<boolean>;

  constructor(
    public loaderService: LoaderService,
    private router: Router,
    private renderer: Renderer2,
    private store: Store<{ darkMode: boolean }>
  ) {
    this.darkMode$ = store.select('darkMode');
  }

  public applySearch(): void {
    const term = (this.searchTerm || '').trim().toLowerCase();
    this.filteredTools = !term
      ? this.toolInformation
      : this.toolInformation.filter(tool =>
          tool.title.toLowerCase().includes(term) ||
          (tool.subTitle || '').toLowerCase().includes(term)
        );
  }

  public clearSearch(): void {
    this.searchTerm = '';
    this.applySearch();
  }

  // A tool either opens in the admin tool, links out to SharePoint, or is not
  // ready yet, which decides both the card badge and whether it can be opened
  public isAvailable(tool: ITool): boolean {
    return !tool.disableOpenButton && !!tool.route;
  }

  public isExternal(tool: ITool): boolean {
    return !!tool.folderLocationLink;
  }

  public toolStatus(tool: ITool): string {
    if (this.isExternal(tool)) {
      return 'SharePoint';
    }
    return this.isAvailable(tool) ? 'Tool' : 'In development';
  }

  public statusBadgeClass(tool: ITool, darkMode: boolean): string {
    if (this.isExternal(tool)) {
      return 'badge-light';
    }
    if (!this.isAvailable(tool)) {
      return 'badge-warning';
    }
    return darkMode ? 'badge-primary-light' : 'badge-primary';
  }

  public openTool(tool: ITool): void {
    if (!this.isAvailable(tool)) {
      return;
    }
    this.renderer.setProperty(document.documentElement, 'scrollTop', 0)
    if (tool.title == 'Static Documents Uploader') {
      this.router.navigate([...(tool.route as Array<string>), this.currentYear]);
    } else {
      this.router.navigate(tool.route as Array<string>);
    }
  }

  public trackByTitle(index: number, tool: ITool): string {
    return tool.title;
  }

}
